<template>
  <div>
    <div class="scheduleWarp">
      <div class="scheduleItem" v-for="v in [0,1,2,3,4,5]" :key="v" >
        <div v-if="v == currenIndex" :style="v == 0 ? 'margin-top:0' : ''" class="scheduleItemActive">
          <div class="pageNum fAm">0{{ currenIndex + 1 }}</div>
        </div>
        <div v-else :style="v == currenIndex ? 'margin-top:0' : ''" class="scheduleItemNone"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"pageSchedule",
  computed:{
    currenIndex(){
      return this.$store.getters.homeIndex;
    }
  }
}
</script>
<style scoped lang="scss">
  .scheduleWarp{
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    right: 5rem;
    z-index: 9999;
    .scheduleItem{
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      flex-direction: column;
      .scheduleItemActive{
        width: 22px;
        height: 3px;
        background-color: #fff;
        margin-top: 10px;
        position: relative;
        .pageNum{
          position: absolute;
          left: -22px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          color: #fff;
          font-size: .9rem;
        }
      }
      .scheduleItemNone{
        width: 10px;
        height: 2px;
        background-color: #fff;
        margin-top: 10px
      }
    }
  }
</style>
